const url = '/terms-of-use';
export default url;
